import { render, staticRenderFns } from "./MedicalItemsListPopup.vue?vue&type=template&id=348ec8b6"
import script from "./MedicalItemsListPopup.vue?vue&type=script&lang=js"
export * from "./MedicalItemsListPopup.vue?vue&type=script&lang=js"
import style0 from "./MedicalItemsListPopup.vue?vue&type=style&index=0&id=348ec8b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports